import { styled } from '@mui/material/styles'
import React from 'react'
import { required, SimpleForm, TextInput } from 'react-admin'
import {
  activityStatusChoices,
  serviceDiscriminatorChoices,
} from 'services/cfg/form'
import { serviceWhereAvailable } from 'services/cfg/rules'
import { CustomFormProps } from 'types/common'
import AccordionSuggestion from 'ui-shared/accordions/AccordionSuggestion'
import LastEditDetailsField from 'ui-shared/FormComponents/LastEditDetailsFields'
import KToolTip from 'ui-shared/KTooltip'
import DescriptionInput from 'ui-shared/WrappedInputs/DescriptionInput'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'
import KSelectArrayInput from 'ui-shared/WrappedInputs/TailoredFilters/KSelectArrayInput'
import IfClauseForm from './IfClauseForm'
import ThenClauseForm from './ThenClauseForm'

const PREFIX = 'RuleForm'

const classes = {
  dFlexRow: `${PREFIX}-dFlexRow`,
  inputW250px: `${PREFIX}-inputW250px`,
  inputW800px: `${PREFIX}-inputW800px`,
  w100: `${PREFIX}-w100`,
}

const StyledSimpleForm = styled(SimpleForm)({
  [`& .${classes.dFlexRow}`]: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    width: '100%',
  },
  [`& .${classes.inputW250px}`]: {
    width: '250px',
  },
  [`& .${classes.inputW800px}`]: {
    width: '800px',
  },
  [`& .${classes.w100}`]: {
    width: '100%',
  },
})

type Props = CustomFormProps

const RuleForm: React.FC<Props> = ({ children, ...props }) => {
  const serviceWhereChoices = serviceDiscriminatorChoices.filter((e) =>
    serviceWhereAvailable.includes(e.id)
  )
  return (
    <StyledSimpleForm {...props}>
      <LastEditDetailsField />
      <TextInput
        source="name"
        label="form.fields.name"
        validate={required()}
        fullWidth
      />
      <DescriptionInput />

      <KSelectInput source="status" choices={activityStatusChoices} required />

      <IfClauseForm />

      <ThenClauseForm />

      <KToolTip title="form.fields.servicesWhereTooltip" placement="top">
        <KSelectArrayInput
          className={classes.inputW250px}
          source="servicesWhere"
          choices={serviceWhereChoices}
          validate={required()}
        />
      </KToolTip>

      <AccordionSuggestion
        accordionText={['ruleHowItWorks1', 'ruleHowItWorks2']}
        accordionTitle={'form.fields.howItWorks'}
      />
    </StyledSimpleForm>
  )
}

export default RuleForm
